import { render, staticRenderFns } from "./Enquiry.vue?vue&type=template&id=76b0c10b&scoped=true&"
import script from "./Enquiry.vue?vue&type=script&lang=ts&"
export * from "./Enquiry.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b0c10b",
  null
  
)

export default component.exports